import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

const styles = makeStyles(({ palette }: any) => ({
  icon: {
    color: palette.text.header,
  },
}));

interface GoBackButtonProps {
  onClick: () => void;
  text?: string;
}

const GoBackButton = ({ onClick, text }: GoBackButtonProps) => {
  const classes = styles();
  return (
    <IconButton
      data-testid="go-back-button"
      onClick={onClick}
      size="small"
      className={classes.icon}
      aria-label="Go Back"
    >
      <ChevronLeft fontSize="large" />
      {text && (
        <Typography variant="body1" className={classes.icon}>
          {text}
        </Typography>
      )}
    </IconButton>
  );
};

export default GoBackButton;
